import React from 'react';

export const targetBlankDecorator = (decoratedHref: string, decoratedText: string, key: number) => {
  return <a key={key} href={decoratedHref} target="_blank">{decoratedText}</a>;
};



// WEBPACK FOOTER //
// ./src/utils/LinkifyDecorator.tsx